import { useHistory } from "react-router-dom"
import { Container } from "src/components/container"
import { Image } from "src/components/Image"
import { Button } from "src/components/ui/button"
import { ChevronRight } from "src/icons"
import { WhyUsCard } from "./Card"
import "./style.sass"

export const WhyUsBlock = () => {
  const history = useHistory()
  return (
    <div className="why-us">
      <Container>
        <div className="why-us__header">
          <h1>Why Us?</h1>
          <p>People choose 7Gates because we are simply and best</p>
          <Button color="primary" rightIcon={<ChevronRight />} onClick={() => history.push("/register/personal")}>
            GET STARTED
          </Button>
        </div>
        <div className="why-us__cards">
          <WhyUsCard
            number={1}
            title="Unique cards"
            description="Choose the most convenient and secure prepaid card to manage your funds with ease — enjoy everyday spending, online purchases, and peace of mind knowing your funds are safe"
          >
            <Image src="/why-step1.png" alt="2 Unique cards" />
          </WhyUsCard>
          <WhyUsCard
            number={2}
            title="IBAN Accounts for Personal and Business use"
            description="Choose the most reliable and convenient IBAN account to store your funds — enjoy effortless access, smooth transactions, and the confidence that your money is secure."
          >
            <Image src="/why-step2.png" alt="2 Unique cards" />
          </WhyUsCard>
          <WhyUsCard
            number={3}
            title="Fast & Secure Payouts"
            description="Convert your Bitcoin to cash and enjoy instant transfers to your Credit/Debit Card"
          >
            <Image src="/why-step3.png" alt="2 Unique cards" />
          </WhyUsCard>
          <WhyUsCard
            number={4}
            title="Transparent Fees"
            description="All fees are stated before you proceed with the transaction. No hidden fees & surprises"
          >
            <Image src="/why-step4.png" alt="2 Unique cards" />
          </WhyUsCard>
        </div>
        <WhyUsCard number={5} title="24/7 Support" description="You rest while we support!">
          <div className="why-step5" />
        </WhyUsCard>
      </Container>
    </div>
  )
}
